var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { DialogTypes } from 'common/enums/components/dialog-types.enum';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import authService from 'services/authServise';
import { openDialog, telegramSignIn } from 'store/actions';
var YandexSignInSeamless = function () {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _a = useState(undefined), telegramUserData = _a[0], setTelegramUserData = _a[1];
    var _b = useState(undefined), isExisting = _b[0], setIsExisting = _b[1];
    var search = useLocation().search;
    var useQueryParams = function () {
        return useMemo(function () { return new URLSearchParams(search); }, [search]);
    };
    var query = useQueryParams();
    useEffect(function () {
        var idStr = query.get('id') || undefined;
        var authDateStr = query.get('auth_date');
        setTelegramUserData({
            id: idStr ? parseInt(idStr) : 0,
            first_name: query.get('first_name') || '',
            last_name: query.get('last_name') || undefined,
            auth_date: authDateStr ? parseInt(authDateStr) : 0,
            username: query.get('username') || '',
            photo_url: query.get('photo_url') || '',
            hash: query.get('hash') || ''
        });
    }, []);
    useEffect(function () {
        if (telegramUserData) {
            var checkTelegram = function (telegramData) { return __awaiter(void 0, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, authService.checkTelegram(JSON.stringify({
                                telegramData: telegramData
                            }))];
                        case 1:
                            result = _a.sent();
                            setIsExisting(result || false);
                            return [2 /*return*/];
                    }
                });
            }); };
            checkTelegram(telegramUserData);
        }
    }, [telegramUserData]);
    useEffect(function () {
        if (isExisting !== undefined && telegramUserData) {
            var handleLogin = function (telegramData) {
                dispatch(telegramSignIn(telegramData));
            };
            if (isExisting) {
                handleLogin(telegramUserData);
            }
            else {
                dispatch(openDialog({
                    dialogType: DialogTypes.CreateNewAccountViaSocial,
                    dialogProps: {
                        loginActionFunc: telegramSignIn,
                        loginData: telegramUserData,
                        social: 'Телеграм',
                        accountDataComponent: (_jsxs("div", __assign({ className: "dark:text-white" }, { children: [_jsxs("p", { children: [_jsxs("span", { children: [t('Ваше имя'), ": "] }, void 0), _jsxs("span", { children: [telegramUserData.first_name, " "] }, void 0), _jsx("span", { children: telegramUserData.last_name }, void 0)] }, void 0), _jsxs("p", { children: [_jsx("span", { children: "username: " }, void 0), _jsx("span", { children: telegramUserData.username }, void 0)] }, void 0)] }), void 0))
                    }
                }));
            }
        }
    }, [isExisting]);
    return _jsx(CircularProgressMui, {}, void 0);
};
export default YandexSignInSeamless;
